import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { TrendingSearchMiniEntity } from '../../domain/entities/TrendingSearchMiniEntity'

export class TrendingSearchMiniModel extends TrendingSearchMiniEntity {
  constructor(dataDto: TrendingSearchMiniEntity) {
    super()
    mapEntityProperties<TrendingSearchMiniModel>(this, dataDto)
  }
}
